import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import moment from 'moment';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { adverSetting } from 'lib/api/adverlive';

import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import TopTextArea from 'components/molecules/MbTable/TopTextArea';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const AdverSetting = () => {
  let initParams = {
    sort: 'desc',
    order: 'DEFAULT',
    advrtsPrdtCode: '01,02,03,04,05,06,07,08',
    sDate: moment().add(-31, 'day').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    shopFlag: 'all',
    advrtsTpType: 'all',
    pltfomTpCode: 'all',
    bannerType: 'all',
  };
  const { t } = useTranslation();
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [adverCnt, setAdverCnt] = useState(null);
  //eslint-disable-next-line
  const adverCount = useMemo(() => adverCnt, [adverCnt]);
  const [initialization, setInitialization] = useState(false);

  useEffect(() => {
    setAdverCnt('');
  }, [params]);

  const customized = {
    ADVRTS_PRDT_STR: { orderFlag: true },
    ADVRTS_PRDT_CODE: { merged: true },
    ADVRTS_TP_CODE: { merged: true },
    BROWSER_SESSION_ROAS: {
      makeHead: () => {
        return (
          <>
            {t('브라우져세션ROAS')}
            <br />
            {t('브라우저세션매출')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'BROWSER_SESSION_ROAS');
        const rowData2 = getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['BROWSER_SESSION_ROAS'],
              rowData1.type,
              rowData1.format
            )}
            <br />
            <span className="black">
              {makeRowColumn(
                rowObj['BROWSER_SESSION_ORDER_AMT'],
                rowData2.type,
                rowData2.format
              )}
            </span>
          </>
        );
      },
    },
    BROWSER_SESSION_ORDER_AMT: { merged: true },
    SESSION_ROAS: {
      makeHead: () => {
        return (
          <>
            {t('세션ROAS')}
            <br />
            {t('세션매출')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'SESSION_ROAS');
        const rowData2 = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['SESSION_ROAS'],
              rowData1.type,
              rowData1.format
            )}
            <br />
            <span className="black">
              {makeRowColumn(
                rowObj['SESSION_ORDER_AMT'],
                rowData2.type,
                rowData2.format
              )}
            </span>
          </>
        );
      },
    },
    SESSION_ORDER_AMT: { merged: true },
    DIRECT_ROAS: {
      makeHead: () => {
        return (
          <>
            {t('직접ROAS')}
            <br />
            {t('직접매출')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'DIRECT_ROAS');
        const rowData2 = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['DIRECT_ROAS'],
              rowData1.type,
              rowData1.format
            )}
            <br />
            <span className="black">
              {makeRowColumn(
                rowObj['DIRECT_ORDER_AMT'],
                rowData2.type,
                rowData2.format
              )}
            </span>
          </>
        );
      },
    },
    DIRECT_ORDER_AMT: { merged: true },
    ROAS: {
      makeHead: () => {
        return (
          <>
            {t('총ROAS')}
            <br />
            {t('총매출')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'ROAS');
        const rowData2 = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <>
            {makeRowColumn(rowObj['ROAS'], rowData1.type, rowData1.format)}
            <br />
            <span className="black">
              {makeRowColumn(
                rowObj['ORDER_AMT'],
                rowData2.type,
                rowData2.format
              )}
            </span>
          </>
        );
      },
    },
    ORDER_AMT: { merged: true },
  };

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
    }
  };

  const getTempParam = (newParams, name) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
    }
  };

  /**
   * EnhancedTableContainer callBack 함수
   * @param {obJect} subData
   */
  const useCallBack = (subData) => {
    let newTitle;
    if (subData === 'noData') {
      newTitle = '';
    } else {
      newTitle = '광고주 수 : ' + numeral(subData).format('#,##0');
    }
    setAdverCnt(newTitle);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getTempParam}
          params={tempParams}
          useExternalFilter={false}
          useDisplayFilter={false}
        />
        <FilterCollection
          label={t('노출 형태')}
          name="advrtsPrdtCode"
          params={tempParams}
          value={tempParams.advrtsPrdtCode}
          type="checkbox"
          list={[
            { label: t('배너'), value: '01' },
            { label: t('브랜드커버'), value: '02' },
            { label: t('아이커버'), value: '03' },
            { label: t('쇼콘'), value: '04' },
            { label: t('소셜링크'), value: '05' },
            { label: t('플레이링크'), value: '06' },
            { label: t('네이티브'), value: '07' },
            { label: t('플러스콜'), value: '08' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
          popoverWidth={460}
        />
        <FilterCollection
          label={t('카테고리')}
          name="shopFlag"
          params={tempParams}
          value={tempParams.shopFlag}
          type="radio"
          list={[
            { label: t('전체'), value: 'all' },
            { label: t('쇼핑'), value: '01' },
            { label: t('비쇼핑'), value: '02' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('타게팅구분')}
          name="advrtsTpType"
          params={tempParams}
          value={tempParams.advrtsTpType}
          type="radio"
          list={[
            { label: t('전체'), value: 'all' },
            { label: t('리타겟팅'), value: '01' },
            { label: t('유저타겟팅'), value: '02' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('배너형태')}
          name="bannerType"
          params={tempParams}
          value={tempParams.bannerType}
          type="radio"
          list={[
            { label: '전체', value: 'all' },
            { label: '상품화배너', value: '01' },
            { label: '고정배너', value: '02' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
        />
        <NewButton type="filterButton" name="submit" onClick={getParam}>
          {t('검색')}
        </NewButton>
      </NewFilterWrap>
      <TopTextArea subData={adverCount} />
      <NewTableContainer
        params={params}
        getParam={(newParams) => setParams(newParams)}
        dataReqPromise={adverSetting}
        customized={customized}
        useTotal={false}
        // useFetch={false}
        useSearch={false}
        dataCallBack={useCallBack}
      />
    </>
  );
};

export default AdverSetting;
